const faq = [
  {
    question: "¿Con cuánta anticipación puedo solicitar un turno?",
    answer:
      "Actualmente, con 7 días de anticipación. Esto puede estar sujeto a cambios en función de la disponibilidad y normativas vigentes.",
  },
  {
    question: "¿Cómo puedo reservar un turno?",
    answer:
      "Ir a RESERVAR TURNO (LINKED) > Selecciona la TIENDA de tu preferencia > Selección RANGO DE TURNO disponible > Elige el servicio, cantidad de personas que asistirán > Haz click en el botón RESERVAR > Guarda el código QR con la reserva generada.",
  },
  {
    question: "No puedo hacer reservas para más de 2 o 3 personas. ¿Por qué?",
    answer:
      "Porque las tiendas tienen una capacidad máxima permitida por norma vigente. Cada Cliente puede ingresar con hasta 2 acompañantes. ",
  },
  {
    question: "¿Por cuánto tiempo es válido el turno?",
    answer:
      "El turno es válido para ingresar hasta el horario final del mismo. Ejemplo. Si tu turno es entre las 10 y las 10.30 am, tú puedes ingresar desde las 10 am hasta las 10.30 am. El turno será inválido después de las 10.30.",
  },
  {
    question: " ¿Qué es un código código QR? ¿Es seguro?",
    answer:
      "Es un código que contiene información única. En este caso, allí estarán todos los datos de tu reserva de turno.",
  },
  {
    question: "Hice una reserva de turno. ¿Qué debería hacer ahora?",
    answer:
      "Debes guardar tu código QR como imagen o archivo en tu teléfono, dirigirte a la tienda seleccionada en la fecha y horario elegido y mostrarlo al personal que te reciba en la puerta, para poder ingresar.",
  },
  {
    question: " Tengo un turno entre las 11 y las 11.30 am ¿Qué significa?",
    answer:
      "Significa que puedes ingresar a la tienda en cualquier momento entre las 11 y las 11.30 para comprar o hacer el trámite que necesites.",
  },
  {
    question: "No encuentro un turno disponible en una tienda cercana. ",
    answer:
      "Esto puede suceder porque la tienda está cerrada o bien porque ya no quedan turnos disponibles. Puedes probar en los siguientes días.",
  },
  {
    question: " No puedo generar el turno. ¿Qué puedo hacer?",
    answer:
      "Puedes acercarte a la tienda y pedir un turno en el momento, de acuerdo a la disponibilidad.",
  },
  {
    question: "No pude llegar a tiempo y perdí mi turno. ¿Qué debo hacer?",
    answer:
      " Puedes pedir un nuevo turno o acercarte a la tienda y pedir un turno en el momento, de acuerdo a la disponibilidad.",
  },
  {
    question: "¿Puedo cancelar mi turno?",
    answer:
      "Esta opción aún no está disponible. Puedes pedir un nuevo turno en la tienda y horario que desees.",
  },
  {
    question:
      "¿Qué sucede si no llego a tiempo a la tienda en el horario del turno?",
    answer:
      "Puedes pedir un nuevo turno o acercarte a la tienda y pedir un turno en el momento, de acuerdo a la disponibilidad.",
  },
  {
    question: "Necesito cambiar mi turno.",
    answer:
      "Esta opción aún no está disponible. Puedes pedir un nuevo turno en la tienda y horario que desees.",
  },
  {
    question: "¿Puedo usar mi código QR en una tienda diferente?",
    answer:
      "No. El turno solo es válido en la tienda seleccionada durante la reserva.",
  },
  {
    question:
      "Tengo que hacer la fila cuando llegue a la tienda? à No, puedes pasar directamente a la ",
    answer:
      "tienda, sólo debes mostrarle el tu código QR al guardia en la entrada.",
  },
  {
    question: "¿Por qué necesito compartir mi número de RUT?",
    answer:
      "Si estás ingresando en la App o en F.com como visitante (sin cuenta registrada), lo necesitamos para generar un código único QR que te permita el ingreso.",
  },
];

export default faq;
